import React from 'react';
import {useHistory} from 'react-router-dom';
import {Dropdown} from 'react-bootstrap';
import {SvgIcon} from '../icons/svgIcon';
import {Icons} from '../icons/icons';
import {HibuUiConfiguration} from '../config/config-types';
import {useTranslation} from 'react-i18next';
import {useLocalizationUtil} from '../localizationUtil';

type HeaderMenuProps = {
    config: HibuUiConfiguration;
    isSearchPage: boolean;
    isAnalysisPage: boolean;
};

export const HeaderMenu = React.memo(({config, isSearchPage, isAnalysisPage}: HeaderMenuProps) => {
    const {push} = useHistory();
    const {t} = useTranslation();
    const navigateToAnalysisPage = () => push('/analysis');
    const navigateToSearchPage = () => push('/search');
    const navigateToPage = (url: string, openInNewTab: boolean) => {
        if (openInNewTab) {
            window.open(url, '_blank');
        } else {
            window.location.href = url;
        }
    };
    const {selectedLanguage: currentLanguage} = useLocalizationUtil();


    return (
        <Dropdown id="switch-pages-dropdown" title={''} className="navigation-dropdown">
            <Dropdown.Toggle className="navigation-toggle">
                <SvgIcon icon={Icons.MENU} id="icon-menu"/>
            </Dropdown.Toggle>
            <Dropdown.Menu align="right" className="navigation-menu">
                {config.search.enabled &&
                    <Dropdown.Item eventKey="1" active={isSearchPage} onClick={navigateToSearchPage}>
                        {t('navigation.search')}
                    </Dropdown.Item>
                }
                {config.analysis.enabled &&
                    <Dropdown.Item eventKey="2" active={isAnalysisPage} onClick={navigateToAnalysisPage}>
                        {t('navigation.analysis')}
                    </Dropdown.Item>
                }
                {config.menuItems?.length > 0 && (
                    <>
                        <Dropdown.Divider/>
                        {config.menuItems.map((menuItem) => (
                            <Dropdown.Item key={menuItem.name}
                                           onClick={() => navigateToPage(menuItem.link, menuItem.openInNewTab)}>
                                {menuItem.translations?.[currentLanguage] ?? menuItem.name}
                            </Dropdown.Item>
                        ))}
                    </>)}
            </Dropdown.Menu>
        </Dropdown>
    );
});
